"use client";

import { useEffect, useRef } from "react";

import { usePathname } from "next/navigation";

/**
 * Runs the given callback whenever the pathname changes (including on mount).
 */
export function useOnPathnameChange(onChange: () => void): void {
  const pathname = usePathname();
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    onChangeRef.current();
  }, [pathname]);
}
